export default [
  {
    path: "/programmes/:programmeId/scenarios/:id/results/",
    name: "scenario-results",
    component: () => import("@/features/scenario-analytics/pages/ScenarioAnalyticsPage.vue"),
    props: (route) => ({
      id: Number(route.params.id),
      scenarioId: Number(route.params.id),
      programmeId: Number(route.params.programmeId),
      projectId: Number(route.params.programmeId),
    }),
    meta: {
      requiresAuth: true,
      layout: "app",
      group: "Scenarios",
      title: "Scenario Results",
      breadcrumbs: [
        { name: "Programmes", route: "project-list" },
        { name: "Scenario Select", route: "project-workspace" },
        { name: "Scenario Results", route: "scenario-results" },
      ],
    },
  },

  {
    path: "/scenarios/:id/results/",
    name: "scenario-results-legacy",
    redirect: (to) => ({
      name: "project-list",
      query: {
        scenarioId: to.params.id,
        routeIssue: "missing-programme-id",
      },
    }),
  },
];